<template>
    <main-content>
        <kt-panel>
            <kt-panel-header>
                <kt-panel-header-toolbar>
                    <span v-text="$t('label.charge_by_receipt')"></span>
                </kt-panel-header-toolbar>
            </kt-panel-header>
            <kt-panel-body>
                <div>
                    <form id="receipt_form"
                          @submit.prevent="send($event)">
                        <div class="border in-border-header p-3 my-5">
                            <div class="section-header">
                                {{ `${$t('label.receipt_info')}  '${wallet_title}'` }}
                            </div>

                            <div class="section-body">
                                <kt-row class="mt-2">
                                    <kt-col xs="12" sm="12" md="6" lg="6" xl="6">
                                        <kt-form-group>
                                            <label for="receipt_type">{{ $t('label.receipt_type') }}</label>
                                            <select name="receipt_type" id="receipt_type" disabled
                                                    class="selected form-control" :value="form_data.receipt_type">
                                                <option v-for="(type, index) in receipt_types" :key="index"
                                                        :value="type.value">{{ type.title }}
                                                </option>
                                            </select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="12" md="6" lg="6" xl="6">
                                        <kt-form-group>
                                            <label for="action_type">{{ $t('wallets.label.action_type') }}</label>
                                            <select name="action_type" id="action_type" class="selected form-control"
                                                    v-model="form_data.action_type">
                                                <option
                                                    v-if="form_data.receipt_type !== walletTransactionType.CHARGE_BY_RECEIPT_FINALLY
                                                          || form_data.receipt_type !== walletTransactionType.CHARGE_BY_RECEIPT_THROUGH_AFFILIATE_MARKETER"
                                                    :value="chargeByReceiptActionType.FINALIZE">{{
                                                        chargeByReceiptActionTypeStr.get(chargeByReceiptActionType.FINALIZE)
                                                    }}
                                                </option>
                                                <option
                                                    :value="chargeByReceiptActionType.CANCEL">{{
                                                        chargeByReceiptActionTypeStr.get(chargeByReceiptActionType.CANCEL)
                                                    }}
                                                </option>
                                            </select>
                                        </kt-form-group>
                                    </kt-col>
                                </kt-row>
                            </div>

                            <div>
                                <kt-row class="mt-2">
                                    <kt-col xs="12" sm="12" md="6" lg="6" xl="6">
                                        <kt-form-group>
                                            <label :for="`amount`" v-text="$t('label.amount_rial')"></label>

                                            <input
                                                id="amount"
                                                name="amount"
                                                disabled
                                                v-if="form_data.receipt_type === walletTransactionType.CHARGE_BY_RECEIPT_FINALLY ||
                                                  form_data.receipt_type === walletTransactionType.CHARGE_BY_RECEIPT_THROUGH_AFFILIATE_MARKETER"
                                                class="form-control"
                                                :value="form_data.amount"
                                            >

                                            <amount-input
                                                v-else
                                                :item_id="`amount`"
                                                :item_name="`amount`"
                                                :item="form_data"
                                            ></amount-input>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="12" md="6" lg="6" xl="6">
                                        <kt-form-group>
                                            <label for="followup_code"
                                                   v-text="$t('money_request.followup_code')"></label>
                                            <input
                                                :disabled="form_data.receipt_type !== walletTransactionType.CHARGE_BY_RECEIPT"
                                                id="followup_code"
                                                name="followup_code"
                                                type="text"
                                                v-model="form_data.followup_code"
                                                class="form-control"
                                            >

                                        </kt-form-group>
                                    </kt-col>

                                    <kt-col xs="12" sm="12" md="6" lg="6" xl="6">
                                        <kt-form-group>
                                            <label for="bank_resource"
                                                   v-text="$t('label.bank_account_number')"></label>
                                            <select class="selected form-control" id="bank_resource"
                                                    name="bank_resource"
                                                    :disabled="form_data.receipt_type !== walletTransactionType.CHARGE_BY_RECEIPT"
                                                    v-model="form_data.bank_resource">
                                                <option v-for="(bank_account, index) in all_bank_accounts"
                                                        :key="index"
                                                        v-text="bank_account.number + ' (' + bank_account.bank_fa_name + ')'"
                                                        :value="bank_account.number">
                                                </option>
                                            </select>
                                        </kt-form-group>
                                    </kt-col>

                                    <kt-col xs="12" sm="12" md="6" lg="6" xl="6">
                                        <kt-form-group>
                                            <label for="bank_id"
                                                   v-text="$t('pos.bank')"></label>
                                            <select name="bank_id" class="selected form-control" id="bank_id"
                                                    :disabled="form_data.receipt_type !== walletTransactionType.CHARGE_BY_RECEIPT"
                                                    v-model="form_data.bank_id">
                                                <option :value="bankId.saderat" v-text="bankIdStr.get(bankId.saderat)">
                                                </option>
                                                <option :value="bankId.saman" v-text="bankIdStr.get(bankId.saman)">
                                                </option>
                                                <option :value="bankId.ayande" v-text="bankIdStr.get(bankId.ayande)">
                                                </option>
                                                <option :value="bankId.keshavarzi"
                                                        v-text="bankIdStr.get(bankId.keshavarzi)">
                                                </option>
                                                <option :value="bankId.parsian"
                                                        v-text="bankIdStr.get(bankId.parsian)">
                                                </option>
                                                <option :value="bankId.pasargad"
                                                        v-text="bankIdStr.get(bankId.pasargad)">
                                                </option>
                                                <option :value="bankId.melli"
                                                        v-text="bankIdStr.get(bankId.melli)">
                                                </option>
                                                <option :value="bankId.tejarat"
                                                        v-text="bankIdStr.get(bankId.tejarat)">
                                                </option>
                                                <option :value="bankId.mellat"
                                                        v-text="bankIdStr.get(bankId.mellat)">
                                                </option>
                                            </select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="12" md="6" lg="6" xl="6" v-if="form_data.action_type === chargeByReceiptActionType.FINALIZE">
                                        <kt-form-group>
                                            <label for="payment_date">{{ $t('label.payment_date') }}</label>
                                            <div class="d-flex align-items-center">
                                                <date-picker
                                                    v-model="form_data.payment_date"
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                    input-class="form-control"
                                                    id="payment_date"
                                                    name="payment_date"
                                                    type="datetime"
                                                    required
                                                ></date-picker>
                                                <button
                                                    id="reset_payment_date"
                                                    type="button"
                                                    @click="clearPaymentDate"
                                                    class="btn btn-label-danger ml-2"
                                                >
                                                    <i class="la la-trash-o"></i>
                                                </button>
                                            </div>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="12" md="7" lg="7" xl="7">
                                        <kt-form-group>
                                            <label for="has_receipt_file"
                                                   class="mb-1" v-text="$t('label.should_reduce_wallet_charge_wage')"></label>
                                            <br>
                                            <label class="switch m-0 mr-2 ml-2">
                                                <input id="has_receipt_file"
                                                       name="has_receipt_file"
                                                       v-model="form_data.enable_wage"
                                                       @change="changeStatus($event, form_data.enable_wage)"
                                                       type="checkbox">
                                                <span class="slider round"></span>
                                            </label>

                                        </kt-form-group>
                                    </kt-col>

                                    <kt-col xs="12" sm="12" md="6" lg="6" xl="6">
                                        <kt-form-group>
                                            <label for="receipt_file"
                                                   v-text="$t('label.receipt_image_upload')"></label>
                                            <input
                                                type="file"
                                                :disabled="form_data.receipt_type !== walletTransactionType.CHARGE_BY_RECEIPT"
                                                ref="receipt_file"
                                                id="receipt_file"
                                                name="receipt_file"
                                                class="form-control"
                                                @change="onFileChange($event)"
                                            >

                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="12" md="6" lg="6" xl="6" v-if="url">
                                        <div id="preview">
                                            <div v-if="url" class="border rounded-lg p-3 img-thumbnail">
                                                <button type="button" @click="removeImg()"
                                                        style="position: absolute"
                                                        class="btn btn-danger btn-sm btn-icon rounded-pill"><span
                                                    class="fa fa-window-close"></span></button>
                                                <img v-if="url" :src="url"/>
                                            </div>
                                        </div>
                                    </kt-col>
                                    <kt-col xs="12" sm="12" md="12" lg="12" xl="12" class="mb-2">
                                        <label for="description"
                                               v-text="$t('label.description')"></label>
                                        <textarea id="description" rows="4" name="description" class="form-control"
                                                  v-model="form_data.description"></textarea>

                                    </kt-col>
                                </kt-row>

                                <kt-row class="mt-1 mr-1  justify-content-md-end">
                                    <button class="btn btn-primary  btn-sm" id="submit_btn">
                                        <span class="fa fa-edit"></span>
                                        {{ $t('btn.update') }}
                                    </button>

                                </kt-row>
                            </div>
                        </div>
                    </form>
                </div>
            </kt-panel-body>

        </kt-panel>
    </main-content>
</template>

<script>
import MainContent from "@/components/main-content.vue";
import {i18n} from "@/plugins/i18n";
import AmountInput from "@/components/custom-elements/amount-input.vue";
import {walletService} from "@/common/api.service";
import {bankId, bankIdStr} from "@/constants/bankId";
import {walletTransactionType} from "@/constants/walletTransactionType";
import $ from 'jquery'
import {KTApp} from "@/plugins/core/app";
import {chargeByReceiptActionType, chargeByReceiptActionTypeStr} from "@/constants/chargeByReceiptActionType";

export default {
    name: "UpdateReceipt",
    props: ['hashid'],
    computed: {
        chargeByReceiptActionTypeStr() {
            return chargeByReceiptActionTypeStr
        },
        chargeByReceiptActionType() {
            return chargeByReceiptActionType
        },
        walletTransactionType() {
            return walletTransactionType
        },
        bankIdStr() {
            return bankIdStr
        },
        bankId() {
            return bankId
        },
        slug() {
            return this.$route.params.slug;
        },
        fetchStarshop() {
            return this.slug === 'starshop';
        }
    },
    components: {MainContent, AmountInput},

    data() {
        return {
            form_data: {
                amount: 0,
                receipt_file: '',
                followup_code: '',
                description: '',
                receipt_type: null,
                enable_wage: false,
                action_type: null,
                bank_id: null,
                bank_resource: null,
                payment_date: ''
            },
            url: null,
            receipt_types: [
                {title: i18n.t('label.final_receipt'), value: walletTransactionType.CHARGE_BY_RECEIPT_FINALLY},
                {title: i18n.t('label.affiliate_final_receipt'), value: walletTransactionType.CHARGE_BY_RECEIPT_THROUGH_AFFILIATE_MARKETER},
                {title: i18n.t('label.simple_receipt'), value: walletTransactionType.CHARGE_BY_RECEIPT}
            ],
            all_bank_accounts: [],
            wallet_title: null,
        }
    },

    mounted() {
        let getBankAccountsNumber;
        let getTransactionReceipt;
        if (this.fetchStarshop) {
             getBankAccountsNumber = walletService.getStarShopAllWalletBankAccountNumbers;
             getTransactionReceipt = walletService.getStarShopTransactionReceipt;
        } else {
             getBankAccountsNumber = walletService.getAllWalletBankAccountNumbers;
             getTransactionReceipt = walletService.getTransactionReceipt;
        }
        getBankAccountsNumber().then(res => {
            this.all_bank_accounts = res.data;
        });

        getTransactionReceipt(this.hashid).then(res => {
            this.form_data = {
                payment_date: res.data.data.payment_date,
                amount: res.data.data.amount,
                followup_code: res.data.data.followup_code,
                description: res.data.data.description,
                receipt_type: res.data.data.receipt_type,
                bank_id: res.data.data.bank_id,
                bank_resource: res.data.data.bank_resource,
            }
            this.url = res.data.data.receipt_file
            this.wallet_title = res.data.data.wallet_title
            this.$forceUpdate();
        })

    },

    methods: {
        removeImg() {
            this.url = '';
            this.form_data.receipt_file = null;
            this.$refs.receipt_file.value = null;
            this.$forceUpdate()
        },
        changeStatus() {
            this.file_status = !this.file_status;
            this.$forceUpdate();
        },

        clearPaymentDate() {
            this.form_data.payment_date = null;
        },

        onFileChange(e) {
            const file = e.target.files[0];
            this.url = URL.createObjectURL(file);

            this.form_data.receipt_file = file

            this.$forceUpdate();
        },

        send(e) {
            let form = $(e.target);
            let btn = $('#submit_btn');


            let formData = new FormData();
            formData.append('receipt_type', this.form_data.receipt_type)
            formData.append('description', this.form_data.description)
            formData.append('amount', this.form_data.amount)
            formData.append('action_type', this.form_data.action_type)

            if (this.form_data.action_type === chargeByReceiptActionType.FINALIZE) {
                if (this.filledStr(this.form_data.bank_id))
                    formData.append('bank_id', this.form_data.bank_id)

                formData.append('receipt_file', this.form_data.receipt_file)

                if (this.filledStr(this.form_data.payment_date)) {
                    formData.append('payment_date', this.form_data.payment_date)
                }
                if (this.filledStr(this.form_data.bank_resource))
                    formData.append('bank_resource', this.form_data.bank_resource)
                if (this.filledStr(this.form_data.followup_code))
                    formData.append('followup_code', this.form_data.followup_code)

                formData.append('enable_wage', this.form_data.enable_wage)
            }
            KTApp.progress(btn)

            const updateTransactionReceipt = this.fetchStarshop
                ? walletService.updateStarShopTransactionReceipt
                : walletService.updateTransactionReceipt;

            updateTransactionReceipt(this.hashid, formData)
                .then(({data}) => {
                    this.toastr.success(data.message)

                })
                .catch(({response}) => {
                    if (response.status === 400) {
                        form.validate().showErrors(response.data.data)
                    }
                    this.toastr.error(response.data.message)
                }).finally(() => {
                KTApp.unprogress(btn)
            })
        }
    }
}
</script>

<style scoped>
#preview {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80%;
}

#preview img {
    max-width: 100%;
    max-height: 450px;
}

.slider {
    background-color: #757575;
}

.slider.round {
    border-radius: 100px;
}

.slider.round:before {
    border-radius: 100px;
}

.switch {
    position: relative;
    display: inline-block;
    width: 43px;
    height: 19px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #575757;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 15px;
    width: 15px;
    left: 1px;
    bottom: 2px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}
</style>